import {ResizeHelper} from "../helpers/resize-helper";


export class ImageOverlayHelper{
	public static init(){
		ImageOverlayHelper.doImageOverlay();
		new ResizeHelper(ImageOverlayHelper.resizeFinished);
	}

	private static doImageOverlay(){
		setTimeout(function(){
			const elements = document.getElementsByTagName("img");
			if(elements != null){
				for(let i = 0; i < elements.length;i++){
					let img = elements.item(i);
					let parent = img.parentElement as HTMLElement;
					if(parent != null){
						if(parent.tagName === "A"){
							parent.classList.toggle("overlayLink",true);
							if(parent.getElementsByClassName("imageOverlay").length === 0){
								let overlay = document.createElement("div");
								ImageOverlayHelper.setOverlayStyle(overlay,img);
								overlay.classList.add("imageOverlay");
								parent.appendChild(overlay);
							}else{
								let overlay = parent.getElementsByClassName("imageOverlay").item(0) as HTMLElement;
								ImageOverlayHelper.setOverlayStyle(overlay,img);
							}
						}else if(parent.classList.contains("sshgGallery")){
							parent.classList.toggle("overlayLink",true);
							if(parent.getElementsByClassName("imageOverlay").length === 0){
								let overlay = document.createElement("div");
								ImageOverlayHelper.setOverlayStyle(overlay,img);
								overlay.classList.add("imageOverlay");
								parent.appendChild(overlay);
							}else{
								let overlay = parent.getElementsByClassName("imageOverlay").item(0) as HTMLElement;
								ImageOverlayHelper.setOverlayStyle(overlay,img);
							}
						}
					}
				}
			}
		},50);
	}

	private static setOverlayStyle(overlay: HTMLElement, img:HTMLElement){
		let style = window.getComputedStyle(img);

		overlay.style.marginTop = style.marginTop;
		overlay.style.marginRight= style.marginRight;
		overlay.style.marginBottom = style.marginBottom;
		overlay.style.marginLeft = style.marginLeft;

		if(img.parentElement != null){
			let styleParent = window.getComputedStyle(img.parentElement);
			if(styleParent.paddingTop != null){
				if(parseInt(styleParent.paddingTop) != 0){
					overlay.style.top = styleParent.paddingTop;
				}
			}
			if(styleParent.paddingLeft != null){
				if(parseInt(styleParent.paddingLeft) != 0){
					overlay.style.left = styleParent.paddingLeft;
				}
			}
			if(styleParent.paddingRight != null){
				if(parseInt(styleParent.paddingRight) != 0){
					overlay.style.right = styleParent.paddingRight;
				}
			}
			if(styleParent.paddingBottom != null){
				if(parseInt(styleParent.paddingBottom) != 0){
					overlay.style.bottom = styleParent.paddingBottom;
				}
			}
		}

		if(img.offsetWidth != 0){
			overlay.style.width = img.offsetWidth + "px";
		}
		if(img.offsetHeight != 0){
			overlay.style.height = img.offsetHeight + "px";
		}
	}
	
	private static resizeFinished(){
		ImageOverlayHelper.doImageOverlay();
	}
}